import React from 'react';
import OrderFollowupPage from './OrderFollowupPage';

const DeliveryOrderFollowup = () => (
  <OrderFollowupPage
    title="Delivery Order Followup"
    endpoint="GetOrderInDFollowupList"
    dateRange
    dateByOptions
    requireSearch
  />
);

export default DeliveryOrderFollowup;
